/* app/js/src/components/common/bell-button/bell-button.component.scss */
.icon-button,
button {
  display: block;
  width: 20px;
  height: 20px;
  background: none;
  border: none;
  padding: 0;
  position: relative;
}
.icon-button > svg,
button > svg {
  width: 20px;
  height: 20px;
  fill: #93a9bf;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
}
.icon-button:focus,
button:focus {
  outline: none;
}
.icon-button:hover > svg,
button:hover > svg {
  fill: #ffffff;
}
.icon-button:hover::after,
button:hover::after {
  -ms-transform: translateY(5px);
  -webkit-transform: translateY(5px);
  transform: translateY(5px);
  opacity: 1;
}
.icon-button::after,
button::after {
  content: attr(data-title);
  color: #ffffff;
  font-size: 0.7em;
  margin-left: -10px;
  display: block;
  opacity: 0;
  position: absolute;
  left: -50%;
  width: 300%;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
  -ms-transform: translateY(15px);
  -webkit-transform: translateY(15px);
  transform: translateY(15px);
}
/*# sourceMappingURL=bell-button.component.css.map */
